module.exports = __webpack_public_path__ + "img/touKui5.9c81d00e.png";